<script>
import CMSEditCard from "@/views/components/cms/CMSEditCard.vue";

export default {
  name: "RentenClearUpToolEdit",
  components: {CMSEditCard},
}
</script>

<template>
  <CMSEditCard></CMSEditCard>
</template>

<style scoped>

</style>
